export default {
  pageTitle: 'Job Overview',
  pageSub: 'Real-time summary of tasks, devices, and exceptions',
  postBadge: 'View: Picking Post',
  allTasks: 'All Tasks',
  newDispatch: '+ New Dispatch',
  groupOverall: 'Overall',
  groupToday: "Today's Overview",
  groupOps: 'Exceptions & Devices',
  kpiTaskTotal: 'Total Tasks',
  kpiTaskTotalSub: 'Full flow / pick only / check only',
  kpiTaskDone: 'Completed Tasks',
  kpiTaskDoneSub: 'All steps in the flow passed',
  kpiPickDone: 'Pick Completed',
  kpiPickDoneSub: 'Pick step closed',
  kpiCheckDone: 'Check Passed',
  kpiCheckDoneSub: 'Check step returned',
  kpiTodayTotal: "Today's Total Tasks",
  kpiTodayTotalSub: 'Created today',
  kpiTodayDone: "Today's Completed",
  kpiTodayDoneSub: 'Finished today',
  kpiTodayRate: "Today's Completion Rate",
  kpiTodayRateSub: 'Completed / total today',
  kpiAvgTime: 'Avg Time per Piece',
  kpiAvgTimeSub: 'Last 24h average',
  kpiException: 'Pending Exceptions',
  kpiExceptionSub: 'Need manual closure',
  kpiRobotOnline: 'Robots Online',
  kpiRobotOnlineSub: 'Online in device mgmt',
  kpiRobotWorking: 'Robots Working',
  kpiRobotWorkingSub: 'Currently dispatched',
  kpiPickLines: 'Total Pick Lines',
  kpiPickLinesSub: 'In-stock lines in product library',
  unitCount: '',
  unitItem: '',
  unitRobot: '',
  unitLine: '',
  unitPercent: '%',
  unitSecond: 's',
  taskListTitle: 'Task List',
  taskListHint: 'Shown by task · full flow includes pick and check; pick-only / check-only are single-step',
  viewAll: 'View All',
  colTaskNo: 'Task No.',
  colFlow: 'Flow',
  colStep: 'Current Step',
  colOrderNo: 'Order No.',
  colStation: 'Pick / Check Station',
  colQty: 'Qty',
  colBay: 'Bay',
  colPosition: 'Dock',
  colPickCheck: 'Pick / Check',
  colExcType: 'Exception',
  colStatus: 'Status',
  colProgress: 'Progress',
  colAction: 'Action',
  flowAll: 'Full Flow',
  flowPick: 'Pick Only',
  flowChk: 'Check Only',
  stepPick: 'Pick',
  stepCheck: 'Check',
  stepNone: 'Not Started',
  stepPickRunning: 'Picking',
  stepCheckRunning: 'Checking',
  stepDone: 'Done',
  statusPending: 'Pending',
  statusRunning: 'Running',
  statusDone: 'Done',
  statusException: 'Exception',
  statusHandle: 'To Handle',
  posLeft: 'Left L',
  posRight: 'Right R',
  excMismatch: 'SKU Mismatch',
  excTimeout: 'AGV Timeout',
  excQtyMismatch: 'Qty Mismatch',
  excPendingSuffix: ' · Pending',
  actionDetail: 'Details',
  actionHandle: 'Handle',
}
